import React from "react";
import { Navigate } from "react-router-dom";
import {isSessionStorageItemExists} from "../utils/functions";

interface PrivateRouteProps {
    children: any;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
    const isAuthenticated = isSessionStorageItemExists('userInfo');
    return isAuthenticated ? children : <Navigate to="/error" replace />;
};

